import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import '../styles/AppDownloadPage.css';
import appIcon from '../../assets/logo_white_bg.png';
import googlePlayBadge from '../../assets/google-play-badge.png';
import appStoreBadge from '../../assets/app-store-badge.png';

const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.indiapropertys.app360';
const APP_STORE_URL =
  'https://apps.apple.com/in/app/360coordinates/id6768521931';

const APP_BENEFITS = [
  {
    text: 'Browse rent, sale & resale listings with exact GPS map locations',
    icon: 'map',
  },
  {
    text: 'List properties, manage enquiries, and share precise coordinates with buyers',
    icon: 'manage',
  },
];

const BenefitIcon = ({ type }) => {
  if (type === 'map') {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M12 21s7-4.5 7-11a7 7 0 10-14 0c0 6.5 7 11 7 11z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
        <circle cx="12" cy="10" r="2.5" fill="currentColor" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M4 7h16M4 12h10M4 17h14"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M18 10v8l3-2"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const PhoneMockup = ({ playStoreUrl }) => (
  <div className="appdownload-phone">
    <div className="appdownload-phone-notch" />
    <div className="appdownload-phone-screen">
      <div className="appdownload-phone-search">
        <span>Search cities, localities, projects…</span>
      </div>
      <div className="appdownload-phone-location">
        <span>Buy in Mumbai</span>
        <svg viewBox="0 0 12 12" width="10" height="10" aria-hidden="true">
          <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" fill="none" />
        </svg>
      </div>
      <div className="appdownload-phone-chips">
        <span>Buy in Pune</span>
        <span>Buy in Noida</span>
        <span>Explore new</span>
      </div>
      <p className="appdownload-phone-section-title">Recommended Properties</p>
      <div className="appdownload-phone-cards">
        <div className="appdownload-phone-card">
          <div className="appdownload-phone-card-img" />
          <div className="appdownload-phone-card-body">
            <span className="appdownload-phone-verified">Verified</span>
            <span className="appdownload-phone-price">₹81.6 Lacs</span>
            <span className="appdownload-phone-meta">2 BHK · Andheri West</span>
          </div>
        </div>
        <div className="appdownload-phone-card">
          <div className="appdownload-phone-card-img appdownload-phone-card-img--alt" />
          <div className="appdownload-phone-card-body">
            <span className="appdownload-phone-verified">Verified</span>
            <span className="appdownload-phone-price">₹1.2 Cr</span>
            <span className="appdownload-phone-meta">3 BHK · Bandra</span>
          </div>
        </div>
      </div>

      <a
        href={playStoreUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="appdownload-phone-qr"
        aria-label="Scan QR code to download 360Coordinates on Google Play"
      >
        <QRCodeSVG
          value={playStoreUrl}
          size={128}
          level="M"
          bgColor="#ffffff"
          fgColor="#0b3d6e"
          includeMargin={false}
          className="appdownload-phone-qr-image"
        />
      </a>

      <div className="appdownload-phone-free-download">
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M12 4v10m0 0l3.5-3.5M12 14l-3.5-3.5M5 18h14"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span>Scan here to free Download</span>
      </div>
    </div>
  </div>
);

const AppDownloadPage = () => {
  const handleAndroidDownload = () => {
    window.open(PLAY_STORE_URL, '_blank', 'noopener,noreferrer');
  };

  const handleIOSDownload = () => {
    window.open(APP_STORE_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="appdownload-page">
      <section className="appdownload-hero">
        <div className="appdownload-hero-inner">
          <div className="appdownload-hero-copy">
            <div className="appdownload-copy-card">
              <div className="appdownload-logo-wrap">
                <img src={appIcon} alt="360Coordinates" className="appdownload-logo" />
              </div>

              <div className="appdownload-copy-body">
              <h1 className="appdownload-title">
                Download{' '}
                <span className="appdownload-title-highlight">360Coordinates</span>
                {' '}Mobile App
              </h1>
              {/* <p className="appdownload-subtitle">
                Find, list &amp; manage properties with pinpoint GPS accuracy — anytime, anywhere.
              </p> */}

              <ul className="appdownload-benefits">
                {APP_BENEFITS.map(({ text, icon }) => (
                  <li key={text} className="appdownload-benefit-card">
                    <span className="appdownload-benefit-icon">
                      <BenefitIcon type={icon} />
                    </span>
                    <span className="appdownload-benefit-text">{text}</span>
                  </li>
                ))}
              </ul>

              <div className="appdownload-store-section">
                <p className="appdownload-store-label">Get the app on click below — it&apos;s free</p>
                <div className="appdownload-store-buttons">
              <button
                type="button"
                className="appdownload-store-btn appdownload-store-btn--google"
                onClick={handleAndroidDownload}
                aria-label="Get it on Google Play"
              >
                <img src={googlePlayBadge} alt="Get it on Google Play" />
              </button>
              <button
                type="button"
                className="appdownload-store-btn appdownload-store-btn--apple"
                onClick={handleIOSDownload}
                aria-label="Download on the App Store"
              >
                <img src={appStoreBadge} alt="Download on the App Store" />
              </button>
                </div>
              </div>
              </div>
            </div>
          </div>

          <div className="appdownload-hero-visual">
            <div className="appdownload-mobile-unit">
              <div className="appdownload-phone-stage">
                <PhoneMockup playStoreUrl={PLAY_STORE_URL} />

                <div className="appdownload-notification-bell" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 3a5 5 0 00-5 5v3.5l-1.2 2.4a1 1 0 00.9 1.5h10.6a1 1 0 00.9-1.5L17 11.5V8a5 5 0 00-5-5z"
                      fill="currentColor"
                    />
                    <path d="M10 19a2 2 0 004 0" stroke="currentColor" strokeWidth="1.5" />
                  </svg>
                  <span className="appdownload-notification-dot" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="appdownload-footer">
        <p>© {new Date().getFullYear()} 360Coordinates. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default AppDownloadPage;
